import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AntiAuthGuard } from 'src/app/shared/guards/anti-auth.guard';
import { EmailUnsubscribePermissionResolver } from 'src/app/shared/guards/unsuscribe-auth.resolver';
import { LoginComponent } from './login/login.component';
import { PasswordResetSuccessfulComponent } from './password-reset-successful/password-reset-successful.component';
import { ResetLinkSentComponent } from './reset-link-sent/reset-link-sent.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpAcknowledgeComponent } from './sign-up-acknowledge/sign-up-acknowledge.component';
import { SignUpVerifiedComponent } from './sign-up-verified/sign-up-verified.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { UnsubscribeEmailComponent } from './unsubscribe-email/unsubscribe-email.component';

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        children: [
            {
                path: '',
                component: SignInComponent,
            },
            {
                path: 'reset_password',
                component: ResetPasswordComponent,
            },
            {
                path: 'reset_link_sent',
                component: ResetLinkSentComponent,
            },
            {
                path: 'signUp',
                component: SignUpComponent,
            },
            {
                path: 'acknowledge',
                component: SignUpAcknowledgeComponent,
            },
            {
                path: 'set_new_password',
                component: SetNewPasswordComponent,
            },
            {
                path: 'password_reset_success',
                component: PasswordResetSuccessfulComponent,
            },
            {
                path: 'account_verified',
                component: SignUpVerifiedComponent,
            },
        ],
        canActivate: [AntiAuthGuard],
    },
    {
        path: "landing/unsubscribe",  // Needed to remove this route after one month, this route only used for unsubscribe daily mails
        component: UnsubscribeEmailComponent,
        resolve: {
            EmailUnsubscribePermissionResolver: EmailUnsubscribePermissionResolver,
        }
    },
    {
        path: "unsubscribe",
        component: UnsubscribeEmailComponent,
        resolve: {
            EmailUnsubscribePermissionResolver: EmailUnsubscribePermissionResolver,
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthRoutingModule {}
